"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var Right = function Right() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: "20",
    height: "40",
    viewBox: "0 0 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M-3.21455e-05 40H20L0.000160602 19.1038L20 0C20 0 8.09197 0 -3.21455e-05 0V40Z",
      fill: "#5BBC81"
    })
  });
};
var _default = Right;
exports["default"] = _default;